import React from "react";
import { Box, Typography } from "@material-ui/core";

const ContentHome: React.VFC = () => (
  <Box display="flex" alignItems="center" justifyContent="center" height="70vh">
    <Typography variant="h3" color="textSecondary">
      content
    </Typography>
  </Box>
);

export default ContentHome;
